import { get, post, withUrl } from '../rest';


export namespace Auth {
    export type RedirectUrl = {
        redirectUrl: string;
    };

    export type IdentityToken = {
        identityToken: string;
    };

    export type Code = {
        code: string;
    };

    export type RefreshToken = {
        refreshToken: string;
    };

    export type TokensResponse = {
        RefreshToken: string;
        AccessToken: string;
        IdentityToken: string;
    }

    export type RefreshTokensResponse = {
        RefreshToken: string;
        AccessToken: string;
    }
}


const authPart = withUrl('auth');

export const auth = {
    check: get<void, void>(() => authPart({
        path: 'check',
    })),

    stsLoginUrl: get<Auth.RedirectUrl, string>(
        ({ redirectUrl }) => authPart({
            path: 'stsloginurl',
            query: {
                redirectUrl,
            },
        }),
    ),
    stsLogoutUrl: get<Auth.RedirectUrl & Auth.IdentityToken, string>(
        ({ identityToken, redirectUrl }) => authPart({
            path: 'stslogouturl',
            query: {
                identityToken,
                redirectUrl,
            },
        }),
    ),

    tokens: post<Auth.Code & Auth.RedirectUrl, Auth.TokensResponse>(
        ({ code, redirectUrl }) => authPart({
            path: 'tokens',
            body: {
                Code: code,
                RedirectUrl: redirectUrl,
            },
        }),
    ),
    refreshTokens: post<Auth.RefreshToken, Auth.RefreshTokensResponse>(
        ({ refreshToken }) => authPart({
            path: 'refreshtokens',
            body: {
                RefreshToken: refreshToken,
            },
        }),
    ),
};
